<template>
  <label class="field">
    <input
      type="checkbox"
      class="switch is-rounded"
      :checked="value"
      @click="onChange"
      :disabled="disabled"
    />
    <span class="label">{{ $t(label) }}</span>
  </label>
</template>

<script>
export default {
  name: "switch-field",
  props: ["label", "value", "disabled"],
  methods: {
    onChange(event) {
      const value = event.target.checked
      this.$emit("change", value)
      this.$emit("input", value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/style.scss";

.field {
  padding-top: 0.2rem;
}
@keyframes spinAround {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
}

.switch {
  outline: 0;
  user-select: none;
  display: inline-block;
  position: absolute;
  opacity: 0;

  &:focus + .label::after,
  &:focus + .label::before {
    outline: 1px dotted $grey-light;
  }
  &[disabled] {
    cursor: not-allowed;
  }
  &[disabled] + .label {
    opacity: 0.5;
    &::before,
    &::after {
      opacity: 0.5;
    }
    &:hover {
      cursor: not-allowed;
    }
  }

  & + .label {
    position: relative;
    display: initial;
    font-size: 1rem;
    padding-left: 3rem;
    padding-top: 0.2rem;
    cursor: pointer;
    &::before {
      position: absolute;
      display: block;
      top: 0;
      left: 0;
      width: 3rem;
      height: 1.5rem;
      border: 0.1rem solid transparent;
      border-radius: 4px;
      background: $grey-light;
      content: "";
    }
    &::after {
      display: block;
      position: absolute;
      top: 0.25rem;
      left: 0.25rem;
      width: 1rem;
      height: 1rem;
      border-radius: 4px;
      background: $white;
      transition: all 0.12s ease-out;
      content: "";
    }
  }
  &:checked + .label {
    &::before {
      background: $primary;
    }
    &::after {
      left: 1.625rem;
    }
  }
  &::before {
    background-color: transparent;
    border-color: $primary;
  }
  &::after {
    background: $primary;
  }
  &.is-rounded + .label {
    &::before {
      border-radius: 24px;
    }
    &::after {
      border-radius: 50%;
    }
  }
}
</style>
